import React from "react";
import { Navigate, useNavigate } from "react-router-dom";


const WithAuth = (Component) => {
  // const navigate = useNavigate()
  return (props) => {
    if (sessionStorage.getItem("token") !== "success") {
      return <Navigate to="/login" />;
    } else {
      return <Component {...props} />;
    }
  };
};

export default WithAuth;
